
// Namespacing

window.site = (window.site || {});


// MusicPlayer - opened / close

site.MusicPlayer = (function MusicPlayer($) {

  'use strict';

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false,
    $carousel = null;

    /**
     * Initializes the class.
     * @public
     */
    var init = function() {

      // Abort if already initialized
      if (inited) {
        return false;
      }

      inited = true;

      // Initiate MusicPlayer
      initPlayer();

      return true;

    };

    // ------------------------------------
    // EVENT HANDLERS
    // ------------------------------------

    var initPlayer = function() {

      $('.player-cta').on('click', 'a', function(event) {
        event.preventDefault();

        var type = $(this).data('trigger-player');

        $('#music-player div').hide();
        $('#music-player').find('.player-'+type+'').show();
      });

    };

    return {
      init: init
    };

}.bind(site, jQuery)());

